/* esm.sh - applesauce-common@5.2.0/dist/helpers/relay-discovery */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/relay-discovery.mjs";
